import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../redux/ducks/TeacherDucks';
import { actions as actionsCourses } from '../../../redux/ducks/CourseDucks';
import { RootState } from '../../../redux/store';

// Components
import TableTeacher from '../../../components/TableTeacher/TableTeacher';
import DialogConfirm from '../../../components/DialogConfirm/DialogConfirm';
// eslint-disable-next-line max-len
import ContainerBreadcrumbs from '../../../components/ContainerBreadcrumbs/ContainerBreadcrumbs';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import Card from '../../../components/Card/Card';

const TeacherList: React.FC = () => {
  const dispatch = useDispatch();

  const history = useHistory();

  const teachersInStore = useSelector(
    ( state: RootState ) => state.teacher.teachers,
  );

  const [open, setOpen] = useState( false );
  const [idDoc, setIdDoc] = useState( '' );

  useEffect(() => {
    dispatch( actions.getTeachers());
    dispatch( actionsCourses.getCourses());
  }, []);

  const handleOpenConfirm = ( id: string ): void => {
    setIdDoc( id );
    setOpen( true );
  };

  const handleNew = (): void => {
    history.push( `/admin/docentes/agregar` );
  };

  const handleEdit = ( id: string ): void => {
    history.push( `/admin/docentes/editar/${id}` );
  };

  const handleDelete = ( confirm: boolean ): void => {
    if ( confirm ) {
      dispatch( actions.deleteTeacher( idDoc ));
    }
    setOpen( false );
  };

  const handleUploadData = (): void => {
    history.push( `/admin/docentes/carga-masiva` );
  };

  const handleShow = ( id: string ): void => {
    history.push( `/admin/docentes/ver/${id}` );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card>
          <ContainerBreadcrumbs>
            <Breadcrumbs
              back={false}
              itemsLinks={[{ name: 'Docentes', url: 'admin/docentes' }]}
              itemsText={['Todos los docentes']}
            />
          </ContainerBreadcrumbs>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <TableTeacher
            teachers={teachersInStore}
            handleDelete={handleOpenConfirm}
            handleEdit={handleEdit}
            handleNew={handleNew}
            handleUpload={handleUploadData}
            handleShow={handleShow}
          />
        </Card>
      </Grid>
      <DialogConfirm
        open={open}
        title="¿ Desea eliminar al docente ?"
        onClose={handleDelete}
      />
    </Grid>
  );
};

export default TeacherList;
